// Life Story Studio + Timeline + People + Interview API client
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const authHeaders = () => {
  const token = localStorage.getItem("shweebum_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// ---------- Life Story ----------
export const lifeStoryApi = {
  create: async (body) => (await axios.post(`${API}/life-stories`, body, { headers: authHeaders() })).data,
  get: async (pid) => (await axios.get(`${API}/life-stories/${pid}`, { headers: authHeaders() })).data,
  update: async (pid, body) => (await axios.patch(`${API}/life-stories/${pid}`, body, { headers: authHeaders() })).data,

  addPart: async (pid, body) => (await axios.post(`${API}/life-stories/${pid}/parts`, body, { headers: authHeaders() })).data,
  removePart: async (pid, partId) => (await axios.delete(`${API}/life-stories/${pid}/parts/${partId}`, { headers: authHeaders() })).data,
  addSection: async (pid, partId, body) => (await axios.post(`${API}/life-stories/${pid}/parts/${partId}/sections`, body, { headers: authHeaders() })).data,
  removeSection: async (pid, partId, sectionId) => (await axios.delete(`${API}/life-stories/${pid}/parts/${partId}/sections/${sectionId}`, { headers: authHeaders() })).data,

  listChapters: async (pid, filters = {}) => {
    const p = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== "") p.append(k, v); });
    return (await axios.get(`${API}/life-stories/${pid}/chapters?${p.toString()}`, { headers: authHeaders() })).data;
  },
  createChapter: async (pid, body) => (await axios.post(`${API}/life-stories/${pid}/chapters`, body, { headers: authHeaders() })).data,
  getChapter: async (pid, cid) => (await axios.get(`${API}/life-stories/${pid}/chapters/${cid}`, { headers: authHeaders() })).data,
  updateChapter: async (pid, cid, body) => (await axios.patch(`${API}/life-stories/${pid}/chapters/${cid}`, body, { headers: authHeaders() })).data,
  deleteChapter: async (pid, cid) => (await axios.delete(`${API}/life-stories/${pid}/chapters/${cid}`, { headers: authHeaders() })).data,
};

// ---------- Timeline ----------
export const timelineApi = {
  list: async (pid, filters = {}) => {
    const p = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== "") p.append(k, v); });
    return (await axios.get(`${API}/projects/${pid}/timeline?${p.toString()}`, { headers: authHeaders() })).data;
  },
  create: async (pid, body) => (await axios.post(`${API}/projects/${pid}/timeline`, body, { headers: authHeaders() })).data,
  update: async (pid, eid, body) => (await axios.patch(`${API}/projects/${pid}/timeline/${eid}`, body, { headers: authHeaders() })).data,
  remove: async (pid, eid) => (await axios.delete(`${API}/projects/${pid}/timeline/${eid}`, { headers: authHeaders() })).data,
};

// ---------- People ----------
export const peopleApi = {
  list: async (pid, filters = {}) => {
    const p = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => { if (v !== undefined && v !== null && v !== "") p.append(k, v); });
    return (await axios.get(`${API}/projects/${pid}/people?${p.toString()}`, { headers: authHeaders() })).data;
  },
  create: async (pid, body) => (await axios.post(`${API}/projects/${pid}/people`, body, { headers: authHeaders() })).data,
  update: async (pid, perId, body) => (await axios.patch(`${API}/projects/${pid}/people/${perId}`, body, { headers: authHeaders() })).data,
  remove: async (pid, perId) => (await axios.delete(`${API}/projects/${pid}/people/${perId}`, { headers: authHeaders() })).data,
};

// ---------- Interview ----------
export const interviewApi = {
  packs: async () => (await axios.get(`${API}/interview/packs`)).data,
  pack: async (packId) => (await axios.get(`${API}/interview/packs/${packId}`)).data,

  listSessions: async (pid) => (await axios.get(`${API}/projects/${pid}/interview/sessions`, { headers: authHeaders() })).data,
  createSession: async (pid, body) => (await axios.post(`${API}/projects/${pid}/interview/sessions`, body, { headers: authHeaders() })).data,
  getSession: async (pid, sid) => (await axios.get(`${API}/projects/${pid}/interview/sessions/${sid}`, { headers: authHeaders() })).data,
  upsertAnswer: async (pid, sid, body) => (await axios.post(`${API}/projects/${pid}/interview/sessions/${sid}/answers`, body, { headers: authHeaders() })).data,
  promote: async (pid, answerId, body) => (await axios.post(`${API}/projects/${pid}/interview/answers/${answerId}/promote`, body, { headers: authHeaders() })).data,
};
